module.exports = __webpack_public_path__ + "img/4d84edf.jpeg";